import React from "react";
import { Typography, Button } from "antd";
import { Camera, Package, FileText } from "lucide-react";

const { Title, Text } = Typography;

interface PhotoTypeSelectionProps {
  onSelectType: (type: "inventory" | "document") => void;
}

const PhotoTypeSelection: React.FC<PhotoTypeSelectionProps> = ({
  onSelectType,
}) => {
  return (
    <div className="mb-6">
      <div className="flex justify-between items-center mb-4">
        <Title level={4}>Take Photos</Title>
        <Button
          type="primary"
          icon={<Camera />}
          onClick={() => onSelectType("inventory")}
        >
          New Photo
        </Button>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <Button
          className="p-4 flex flex-col items-center justify-center h-auto"
          onClick={() => onSelectType("inventory")}
        >
          <Package size={32} className="text-blue-600" />
          <Text>Inventory Item</Text>
        </Button>
        <Button
          className="p-4 flex flex-col items-center justify-center h-auto"
          onClick={() => onSelectType("document")}
        >
          <FileText size={32} className="text-green-600" />
          <Text>Document</Text>
        </Button>
      </div>
    </div>
  );
};

export default PhotoTypeSelection;
